import React from "react";

import { ReactComponent as AccountCreation } from "../../../assets/icons/account-creation-small.svg";
import { ReactComponent as GenistaLogo } from "../../../assets/icons/genista-logo-small.svg";
import { ReactComponent as AccountCoolDark } from "../../../assets/images/logo/AccountCoolDark.svg";
import { ReactComponent as ContactInfoCoolDark } from "../../../assets/images/logo/ContactInfoCoolDark.svg";
import { ReactComponent as CustomerInfoCoolDark } from "../../../assets/images/logo/CustomerInfoCoolDark.svg";
import { ReactComponent as BuildingIcon } from "../../../assets/images/subscriptions/building-line.svg";

import { designTokens } from "../../../styles/tokens";

export const RenderIconOnNextClick = function renderStepsIcon({ Inx }) {
  switch (Inx) {
    case 0:
      return <CustomerInfoCoolDark />;
    case 1:
      return <ContactInfoCoolDark />;
    case 2:
      return <GenistaLogo />;
    case 3:
      return <BuildingIcon />;
    case 4:
      return <AccountCoolDark />;
    default:
      return <CustomerInfoCoolDark />;
  }
};

export const RenderIconOnNextClickForCustomerExist = function renderStepsIcon({ Inx }) {
  switch (Inx) {
    case 0:
      return <CustomerInfoCoolDark />;
    case 1:
      return <GenistaLogo />;
    case 2:
      return <BuildingIcon />;
    case 3:
      return <AccountCoolDark />;
    default:
      return <CustomerInfoCoolDark />;
  }
};

export const RenderIconOnPreviousClick = function renderStepsIcon({ Inx }) {
  switch (Inx) {
    case 0:
      return <CustomerInfoCoolDark />;
    case 1:
      return <ContactInfoCoolDark fill={designTokens.colorContentTertiary} />;
    case 2:
      return <GenistaLogo fill={designTokens.colorContentTertiary} />;
    case 3:
      return <BuildingIcon fill={designTokens.colorContentTertiary} />;
    case 4:
      return <AccountCreation fill={designTokens.colorContentTertiary} />;
    default:
      return <CustomerInfoCoolDark fill={designTokens.colorContentTertiary} />;
  }
};

export const RenderIconOnPreviousClickForCustomerExist = function renderStepsIcon({ Inx }) {
  switch (Inx) {
    case 0:
      return <CustomerInfoCoolDark />;
    case 1:
      return <GenistaLogo fill={designTokens.colorContentTertiary} />;
    case 2:
      return <BuildingIcon fill={designTokens.colorContentTertiary} />;
    case 3:
      return <AccountCreation fill={designTokens.colorContentTertiary} />;
    default:
      return <CustomerInfoCoolDark fill={designTokens.colorContentTertiary} />;
  }
};
